import React from "react";

const Loader = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="[&>span]:before:animate-fadeIn relative h-6 w-6 [&>span]:absolute [&>span]:inset-0 [&>span]:inline-flex [&>span]:h-full [&>span]:w-full [&>span]:before:h-1 [&>span]:before:w-1 [&>span]:before:rounded-full [&>span]:before:bg-white mt-6">
        <span className=""></span>
        <span className="before:!animation-delay-[-1.1s] rotate-[30deg]"></span>
        <span className="before:!animation-delay-[-1s] rotate-[60deg]"></span>
        <span className="before:!animation-delay-[-0.9s] rotate-[90deg]"></span>
        <span className="before:!animation-delay-[-0.8s] rotate-[120deg]"></span>
        <span className="before:!animation-delay-[-0.7s] rotate-[150deg]"></span>
        <span className="before:!animation-delay-[-0.6s] rotate-[180deg]"></span>
        <span className="before:!animation-delay-[-0.5s] rotate-[210deg]"></span>
        <span className="before:!animation-delay-[-0.4s] rotate-[240deg]"></span>
        <span className="before:!animation-delay-[-0.3s] rotate-[270deg]"></span>
        <span className="before:!animation-delay-[-0.2s] rotate-[300deg]"></span>
        <span className="before:!animation-delay-[-0.1s] rotate-[330deg]"></span>
      </div>
    </div>
  );
};

export default Loader;
